import { render, staticRenderFns } from "./DataTableHeader.vue?vue&type=template&id=1069294e&"
import script from "./DataTableHeader.vue?vue&type=script&lang=js&"
export * from "./DataTableHeader.vue?vue&type=script&lang=js&"
import style0 from "./DataTableHeader.vue?vue&type=style&index=0&id=1069294e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports